<template>
	<section class="section">
		<div class="container">
			<h3 class="title is-3">Фискален сервер</h3>

			<article v-if="!fiscalServerAvailable" class="message is-danger">
				<div class="message-body">Фискалниот сервер не е достапен</div>
			</article>

			<div v-else class="columns">
				<div class="column">
					<button
						class="button is-primary"
						:class="{ 'is-loading': loading === 'control' }"
						:disabled="loading !== null"
						@click="fetchControlReport"
					>
						Контролен извештај
					</button>
				</div>
				<div class="column">
					<!-- The day report closes the fiscal day and can't be undone, so it takes a second click. -->
					<div class="buttons" v-if="confirmingCloseDay">
						<button
							class="button is-danger"
							:class="{ 'is-loading': loading === 'closeDay' }"
							:disabled="loading !== null"
							@click="fetchCloseDayReport"
						>
							Потврди затворање на денот
						</button>
						<button
							class="button"
							:disabled="loading !== null"
							@click="confirmingCloseDay = false"
						>
							Назад
						</button>
					</div>
					<button
						v-else
						class="button is-danger"
						:disabled="loading !== null"
						@click="confirmingCloseDay = true"
					>
						Затвори дневен извештај
					</button>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import {fiscalError} from "../api/fiscalService";

export default {
	name: "Fiscal",
	data() {
		return {
			// Which report is running: "control", "closeDay" or null.
			loading: null,
			confirmingCloseDay: false,
		};
	},
	computed: {
		fiscalServerAvailable: function () {
			return this.$store.getters.getFiscalServerAvailable;
		},
	},
	methods: {
		fetchControlReport() {
			this.run("control", this.$fiscalService.controlReport(), "Контролниот извештај е испечатен");
		},
		fetchCloseDayReport() {
			this.run("closeDay", this.$fiscalService.closeDayReport(), "Денот е затворен")
				.then(() => {
					this.confirmingCloseDay = false;
				});
		},
		run(name, request, success) {
			this.loading = name;
			return request
				.then(() => {
					this.$toast({message: success, type: "is-success"});
				})
				.catch((e) => {
					this.$toast({message: fiscalError(e), type: "is-danger"});
				})
				.finally(() => {
					this.loading = null;
				});
		},
	},
};
</script>
<style scoped>
.box {
	cursor: pointer;
}
</style>
